import {BrowserRouter as Router,Routes,Route,Redirect} from 'react-router-dom';
import React, { Suspense, useState, useCallback, useEffect, useRef, useMemo } from 'react'
import './App.css';
 
import Game1 from './Game/Game1';
import Game2 from './Game/Game2';
import Game3 from './Game/Game3';
import Home from './Game/Home';
import Mycard from './Game/Mycard';
import Wallpaper from './Game/Wallpaper'; 
 
function App() {

  
  return (
      <Router>

        <div className='mainContentBox' >
          <Routes>

            <Route   path="/" element={<Home />} />
            <Route   path="/g1" element={<Game1 />} />
            <Route   path="/g2" element={<Game2 />} />
            <Route   path="/g3" element={<Game3 />} />
            <Route   path="/home" element={<Home />} />
            <Route   path="/mycard" element={<Mycard />} />
            <Route   path="/wallpaper" element={<Wallpaper />} />



           

          </Routes>
        </div>

       

      </Router>
  );
}

export default App;
